import React, { useRef, useState } from "react";

import coliflorbechamelImg from "../../images/coliflor-con-bechamel.png";
import batidolecheplatanoImg from "../../images/batido-leche-y-platano.png";
import batidomanzanaavenaImg from "../../images/batido-manzana-y-avena.png";
import yogurplatanonuecesImg from "../../images/yogur-platano-y-nueces.png";
import batidococoplatanoImg from "../../images/batido-coco-y-platano.png";
import membrilloyogurImg from "../../images/membrillo-con-yogur.png";
import yogurproteinasgalletasImg from "../../images/yogur-para-beber-con-proteinas-y-galletas.png";
import natasfrutosrojosImg from "../../images/nata-con-frutos-rojos.png";
import cremanataImg from "../../images/crema-nata.png";
import cremaaceitunasImg from "../../images/crema-aceitunas.png";

function SlideCard({ bg = "bg-[#f4f8fc]", children }) {
  return (
    <div className={`${bg} h-full p-6 rounded-lg shadow overflow-y-auto`}>
      {children}
    </div>
  );
}

export default function RecetasDisfagia() {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  // Slides
  const slides = [
    {
      key: "coliflor-con-bechamel",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>COLIFLOR CON BECHAMEL</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={coliflorbechamelImg}
                alt="COLIFLOR CON BECHAMEL"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para cuatro personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 1 coliflor de tamaño mediano.</li>
              <li>- 4 huevos.</li>
              <li>- 1 cebolla.</li>
              <li>- 2 cucharadas colmadas de harina de repostería.</li>
              <li>- ¾ litros de leche entera.</li>
              <li>- Pizca de nuez moscada.</li>
              <li>- Pimienta.</li>
              <li>- Cebollino.</li>
              <li>- Sal.</li>
              <li>- 5 cucharadas de aceite de oliva.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Cortar la coliflor en ramilletes, lavarla, cocerla y dejarla escurrir (es importante escurrirla bien incluso poner abajo un poco de papel de cocina, para que absorba el agua sobrante).</li>
              <li>- Cocer los huevos.</li>
              <li>- Mientras escurre la coliflor, realizamos la bechamel sofreímos en el aceite, la cebolla rallada, la harina y vamos incorporando lentamente la leche, añadimos la nuez moscada y salpimentamos, sin dejar de remover con una barrilla de cocina hasta conseguir una bechamel fina y sin grumos.</li>
              <li>- Poner en una fuente para horno la coliflor ya escurrida y añadimos la bechamel por encima.</li>
              <li>- Por último, rallamos los huevos por encima.</li>
              <li>- Incorporar un poco de perejil picado en picadora.</li>
              <li>- Introducir en el horno ya precalentado (solo abajo) unos 15 minutos y listo.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Adaptación para pacientes con disfagia:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Si el paciente tiene una disfagia leve y conserva un grado de masticación suficiente, el plato es apto tal y como se presenta (no añadiendo el cebollino ni el perejil picado), para toda la familia, dado que se puede machacar con tenedor y hacer un bolo cohesivo y homogéneo.</li>
              <li>- Si el paciente tiene una disfagia grave, tendremos que triturar la coliflor junto con la bechamel y el huevo (podemos dejar como un ¼ de yema de huevo para darle un toque de color una vez texturizado (rallador muy fino)).</li>
              <li>- Además, este plato lo podemos enriquecer con un poco de nata o quesitos antes de triturarlo, aumentando el valor calórico, si el paciente lo requiere.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "batido-leche-y-platano",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>BATIDO DE LECHE Y PLÁTANO</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={batidolecheplatanoImg}
                alt="BATIDO DE LECHE Y PLÁTANO"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Almendra (20 g).</li>
              <li>- Plátano (150 g).</li>
              <li>- Uva pasa (20 g) sin pepitas.</li>
              <li>- Leche condensada (10 g), una cucharada grande.</li>
              <li>- Leche de vaca entera (200 ml).</li>
              <li>- Espesante (dependiendo del grado de disfagia del paciente añadir la cantidad necesaria para adaptarla a la viscosidad recomendada).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Triturar todo en la batidora, colar y servir fresquito.</li>
              <li>- Añadir el espesante si el batido no se adapta a la viscosidad recomendada.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Enriquecimiento:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Podemos aumentar el valor proteico, añadiéndole (antes de batir) 2 cucharadas de leche en polvo desnatada.</li>
              <li>- Podemos además añadir galletas y triturarlas.</li>
              <li>- Las almendras pueden ser enteras, pero para facilitar la trituración también podemos añadir harina de almendras (2 cucharadas).</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "batido-manzana-y-avena",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>BATIDO DE MANZANA Y AVENA</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={batidomanzanaavenaImg}
                alt="BATIDO DE MANZANA Y AVENA"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Leche de vaca entera (200 ml).</li>
              <li>- Almendras molidas (30 g).</li>
              <li>- Manzana mediana asada y pelada (125 g).</li>
              <li>- Avena unas 3 cucharadas (25 g).</li>
              <li>- Cacao en polvo, si no hay contraindicación, con azúcar (15 g).</li>
              <li>- Leche de vaca en polvo, entera (10 g).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Podemos triturarlo todo y tomarlo en forma de batido, frío o templado.</li>
              <li>- Dependiendo del grado de disfagia, añadir espesante para conseguir la viscosidad segura y eficaz para el paciente.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "yogur-platano-y-nueces",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>YOGUR CON PLÁTANO Y NUECES</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={yogurplatanonuecesImg}
                alt="YOGUR CON PLÁTANO Y NUECES"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Yogur enriquecido con nata (1 yogur griego, 125 g).</li>
              <li>- Nueces (40 g).</li>
              <li>- Plátano mediano muy maduro (125 g).</li>
              <li>- Miel, 2 cucharadas (20 g).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Al igual que el resto, se puede tomar en forma de triturado (si es demasiado espeso), se le puede añadir un poco más de yogur enriquecido con nata o nata líquida.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Enriquecimiento:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Añadir 2 cazos de leche en polvo desnatada.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "batido-coco-y-platano",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>BATIDO DE COCO Y PLÁTANO</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={batidococoplatanoImg}
                alt="BATIDO DE COCO Y PLÁTANO"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Miel (20 g).</li>
              <li>- Coco rallado (50 g).</li>
              <li>- Plátano (250 g).</li>
              <li>- Leche de vaca entera (200 ml).</li>
              <li>- Leche desnatada en polvo (10 g), una cucharada.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Batir todos los ingredientes y servir fresquito.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "membrillo-con-yogur",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>MEMBRILLO CON YOGUR</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={membrilloyogurImg}
                alt="MEMBRILLO CON YOGUR"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Membrillo dulce (150 g).</li>
              <li>- Miel (20 g).</li>
              <li>- Yogur enriquecido con nata (125 g).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Trocear o triturar el membrillo, cubrirlo con yogur, y la miel.</li>
              <li>- También lo pueden realizar en forma de batido, sustituyendo el yogur por leche y dos cazos de leche en polvo desnatada.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "yogur-para-beber-con-proteinas-y-galletas",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>YOGUR PARA BEBER CON PROTEÍNAS Y GALLETAS</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={yogurproteinasgalletasImg}
                alt="YOGUR PARA BEBER CON PROTEÍNAS Y GALLETAS"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Yogur para beber rico en proteínas sabor vainilla.</li>
              <li>- 30 g de galletas María (5 galletas).</li>
              <li>- 30 g de avena.</li>
              <li>- 10 g de miel (1 cucharada).</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Añadir en un recipiente el yogur, las galletas, avena y miel.</li>
              <li>- Triturar todos los ingredientes.</li>
              <li>- Servir a temperatura ambiente o frío.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Comentarios:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Estos yogures, están disponibles en cualquier supermercado, se pueden comprar, bien en forma líquida (para beber) o en forma de yogur (textura pudin) bien solo o añadiéndole ingredientes, son una buena opción para una media mañana, merienda o postre. Según la marca los hay de diferentes sabores (fresa, frambuesa, galleta, caramelo...).</li>
              <li>Esta mezcla es muy espesa, la puede convertir en mas fluida añadiendo leche.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "nata-con-frutos-rojos",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>NATA CON FRUTOS ROJOS</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={natasfrutosrojosImg}
                alt="NATA CON FRUTOS ROJOS"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para una persona:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Fresas (250 g).</li>
              <li>- Frambuesa (100 g).</li>
              <li>- Nata o crema de leche (250 g).</li>
              <li>- 20 g azúcar.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Montar la nata junto con el azúcar.</li>
              <li>- Añadir las frambuesas, fresas y triturar la mezcla.</li>
              <li>- Asegurar que la mezcla es homogénea (sin semillas, pepitas...).</li>
              <li>- Podemos sustituir la nata por yogur griego.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "crema-nata",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>CREMA DE NATA</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={cremanataImg}
                alt="CREMA DE NATA"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Nata y crema de leche (200 g).</li>
              <li>- Leche de vaca, entera (en ml) (60 g).</li>
              <li>- Harina de maíz (maicena) (40 g).</li>
              <li>- Huevo entero grande (7 g).</li>
              <li>- 50 g de azúcar.</li>
              <li>- Zumo de ½ limón y de ½ naranja.</li>
              <li>- Canela.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- En una batidora, añadir todos los ingredientes de la receta a excepción de la nata, triturar y reservar.</li>
              <li>- Calentar la nata sin hervir, cuando esté caliente añadir poco a poco a la mezcla reservada y seguir calentando hasta que espese.</li>
              <li>- Poner en recipientes y dejar enfriar antes de meterlo en la nevera.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "crema-aceitunas",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>CREMA DE ACEITUNAS</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={cremaaceitunasImg}
                alt="CREMA DE ACEITUNAS"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Aceitunas sin hueso (75 g).</li>
              <li>- Mayonesa (150 g).</li>
              <li>- Sal.</li>
              <li>- Pimienta.</li>
              <li>- Zumo de limón.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- En una batidora, añadir todos los ingredientes y triturar hasta conseguir una salsa espesa y homogénea.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Comentarios:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Esta crema es ideal para acompañar pescados y/o patatas.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
  ];

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(slides.length - 1, i + 1));

  // Gestos táctiles
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
  };
  const onTouchMove = (e) => {
    if (touchStartX.current == null) return;
    const currentX = e.touches[0].clientX;
    touchDeltaX.current = currentX - touchStartX.current;
  };
  const onTouchEnd = () => {
    const threshold = 50;
    if (touchDeltaX.current < -threshold) next();
    if (touchDeltaX.current > threshold) prev();
    touchStartX.current = null;
    touchDeltaX.current = 0;
  };

  // Teclado
  const onKeyDown = (e) => {
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Recetas disfagia</h4>
      </div>

      {/* Carrusel con altura fija */}
      <div
        className="relative overflow-hidden rounded-lg h-[520px] sm:h-[580px]"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onKeyDown={onKeyDown}
        tabIndex={0}
        aria-roledescription="carousel"
        aria-label="Recetas de disfagia"
      >
        <div
          className="flex h-full transition-transform duration-300 ease-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.key} className="min-w-full h-full px-0">
              {slide.content}
            </div>
          ))}
        </div>

        {/* Flechas */}
        <button
          type="button"
          onClick={prev}
          disabled={index === 0}
          aria-label="Anterior"
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          ←
        </button>
        <button
          type="button"
          onClick={next}
          disabled={index === slides.length - 1}
          aria-label="Siguiente"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          →
        </button>

        {/* Indicadores */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
          {slides.map((_, i) => (
            <span
              key={i}
              className={`h-2 w-2 rounded-full ${i === index ? "bg-gray-800" : "bg-gray-400"}`}
              aria-label={`Ir al slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Texto + descargable */}
      <div className="flex items-center">
        <p className="text-justify gap-4 mt-2 mb-4">
          Si desea obtener el descargable, pulse en el siguiente{" "}
          <a
            href="/docs/recetas-disfagia.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            enlace
          </a>
          .
        </p>
      </div>
    </div>
  );
}